/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_TitleInputs */

const en_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const fr_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication Iconik`)
};

const de_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const it_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const ru_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const es_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const zh_cn2_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik出版社`)
};

const ja_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publish`)
};

const hi_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइकॉनिक पब्लिश`)
};

const pt_pt2_iconik_publish_title = /** @type {(inputs: Iconik_Publish_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iconik Publica`)
};

/**
* | output |
* | --- |
* | "Iconik Publish" |
*
* @param {Iconik_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_title = /** @type {((inputs?: Iconik_Publish_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_title(inputs)
	if (locale === "de") return de_iconik_publish_title(inputs)
	if (locale === "it") return it_iconik_publish_title(inputs)
	if (locale === "ru") return ru_iconik_publish_title(inputs)
	if (locale === "es") return es_iconik_publish_title(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_title(inputs)
	if (locale === "ja") return ja_iconik_publish_title(inputs)
	if (locale === "hi") return hi_iconik_publish_title(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_title(inputs)
	return en_iconik_publish_title(inputs)
});